import { useFlags } from 'launchdarkly-react-client-sdk'
import { config } from '../../config'
import { Environment } from '../../constants'
import { featureFlagNameToValueMap } from '../useFeatureFlags'

const isProduction = process.env.NODE_ENV === Environment.PRODUCTION

const useSchedulingV2RedirectContext = () => {
  const flags = useFlags()
  const isSchedulingV2Enabled = flags[featureFlagNameToValueMap['SCHEDULING_V2']]
  const schedulingV2Url = config.SCHEDULING_V2_URL
  const isSchedulingV2Supported = !/(^|\/)settings(\/|$)/.test(window.location.pathname)

  const couldRedirectToV2 = isProduction && Boolean(schedulingV2Url) && isSchedulingV2Supported
  const flagNotYetLoaded = Object.keys(flags).length === 0

  return { couldRedirectToV2, flagNotYetLoaded, isSchedulingV2Enabled }
}

// Flag is loaded and confirmed enabled — safe to actually perform the redirect
const useShouldRedirectToSchedulingV2 = (): boolean => {
  const { couldRedirectToV2, isSchedulingV2Enabled } = useSchedulingV2RedirectContext()

  return couldRedirectToV2 && Boolean(isSchedulingV2Enabled)
}

// Redirect might happen (flag enabled OR flag not yet loaded) — other redirects should stand down
const useIsSchedulingV2RedirectPending = (): boolean => {
  const { couldRedirectToV2, flagNotYetLoaded, isSchedulingV2Enabled } = useSchedulingV2RedirectContext()

  return couldRedirectToV2 && (Boolean(isSchedulingV2Enabled) || flagNotYetLoaded)
}

export { useIsSchedulingV2RedirectPending, useShouldRedirectToSchedulingV2 }
